// extracted by mini-css-extract-plugin
export default {"chapterContainer":"Chapter_chapterContainer__OEGwC","para":"Chapter_para__Q2feR","videos":"Chapter_videos__r0Y+C"};